import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { action } from '@ember/object';

export default class AccountOpenController extends Controller {
  @service currentApplicationFlow;
  @service sfsAccountApi;
  @service router;

  @readOnly('sfsAccountApi.primaryAccountDetails.routingNumber')
  routingNumber;
  @readOnly('sfsAccountApi.primaryAccountDetails.fullAccountNumber')
  fullAccountNumber;

  @action
  navigateToAutomationSplash() {
    this.router.transitionTo('signup.automation.splash');
  }
}
